import { FC } from 'react';

import { BadgeBlockContentProps } from '@telialt/core-eshop/src/product/ProductVariationBadges/model';

import { BadgeBlockContainer } from './VariantSelector.styles';

export const RetailVariantBadgeBlock: FC<BadgeBlockContentProps> = ({ children }) => {
    return children ? <BadgeBlockContainer role="radiogroup">{children}</BadgeBlockContainer> : null;
};
